module.exports = __webpack_public_path__ + "img/menu-hair-2.54371963.webp";